<template>
  <div id="configuration">
    <v-container class="-border" v-if="!isEdit">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons(); resetNotificationSettings();">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-form ref="configForm">
        <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12 sm6">
            <v-text-field label="Name" v-model="agencyData.name" class="required" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="formRules.agencyName" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-select :rules="formRules.agencyType" v-model="agencyData.type" label="Type" :items="AgencyType" class="required" @input="changedData">></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <div id="pageEditor" >
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex sm12>
                    <quill-editor
                      :content="agencyData.description"
                      v-model="agencyData.description"
                      :options="editorOption"
                      @input="changedData"
                    >
                    </quill-editor>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6>
            <v-select multiple attach small-chips deletable-chips v-model="agencyData.services" label="Services" :items="agencyServices" class="pr-4 pl-4" @input="changedData">
              <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="toggleSelectAll"
                >
                  <v-list-tile-action>
                    <v-icon :color="agencyData.services.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Select All</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs6 v-if="session.getSession().adminUser">
            <v-select v-model="agencyData.feature_settings[0]" label="Management Options" :items="managementOptions" :rules="[v => !!v.length || 'Please select one']" class="pr-4" @input="changedData">></v-select>
          </v-flex>
        </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12 sm6">
            <v-text-field label="MAP Identifier" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" v-model="agencyData.map_id" :rules="formRules.integer" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-text-field label="MAP Sub Identifier" :rules="formRules.integer" v-model="agencyData.map_sub_id" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-text-field label="MAP URL" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="formRules.websiteRules" v-model="agencyData.map_url" @input="changedData"></v-text-field>
          </v-flex>
          </v-layout>
          
          <!-- Website domain -->
          <v-layout wrap class="pr-4 pl-4 mt-5">
            <v-flex class="xs12">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Website</b>
              </h5>
            </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex class="xs12 sm6">
              <v-text-field label="Agency Website" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" v-model="agencyData.website" :rules="formRules.websiteRules" @input="() => {agencyData.pull_blogs = false; changedData()}"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-checkbox :disabled="!isWebsiteValid" class="ma-0" label="Pull blogs from this site for family websites." v-model="agencyData.pull_blogs" color="teal" @change="validateBlogPull"></v-checkbox>
            </v-flex>
            <v-flex class="xs12 sm6" v-if="agencyData.pull_blogs">
              <v-select
                :items="agencyBlogCategories"
                v-model="agencyData.blog_category"
                label="Blog Category"
                multiple
                small-chips
                deletable-chips
                item-text="name"
                item-value="id"
                :rules="[v => !!v || 'Blog Category is required']"
                :loading="categoriesLoading"
                @change="changedData"
                :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
              ></v-select>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Custom Domain" v-model="agencyData.custom_domain" :rules="formRules.websiteRules" @input="changedData"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout wrap class="pr-4 pl-4 mt-5">
            <v-flex class="xs12">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Badge Contact Information</b>
              </h5>
            </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex class="xs12 sm6">
              <v-text-field label="Contact Name" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" class="required" v-model="agencyData.contact_name" :rules="formRules.contactName" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Phone Number" v-mask="'(###) ###-####'" class="required" v-model="agencyData.phone[0].number" :rules="formRules.number" @input="changedData"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex class="xs12 sm6">
              <v-text-field label="Text Number" v-mask="'(###) ###-####'" v-model="agencyData.fax" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="formRules.faxRules" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Email" class="required" v-model="agencyData.email[0].email" :rules="[formRules.email.required, formRules.email.valid]" @input="changedData"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout wrap class="mt-3 pr-4 pl-4" v-if="agencyData.feature_settings[0] !== 'ChildManagement'">
            <v-flex class="xs12">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Website Contact Information</b>
              </h5>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Phone Number" v-mask="'(###) ###-####'" v-model="agencyData.bm_contact.phone" :rules="formRules.validPhone" @input="changedData" :class="{'pr-4': $vuetify.breakpoint.smAndUp}"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Text Number" v-mask="'(###) ###-####'" v-model="agencyData.bm_contact.text" :rules="formRules.validPhone" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Email" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" v-model="agencyData.bm_contact.email" :rules="[formRules.email.valid]" @input="changedData"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout wrap class="mt-3 pr-4 pl-4" v-if="agencyData.feature_settings[0] !== 'ChildManagement'">
            <v-flex class="xs12">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Parent Advertising Defaults</b>
              </h5>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Phone Number" v-mask="'(###) ###-####'" v-model="agencyData.ad_contact.phone" :rules="formRules.validPhone" @input="changedData" :class="{'pr-4': $vuetify.breakpoint.smAndUp}"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Text Number" v-mask="'(###) ###-####'" v-model="agencyData.ad_contact.text" :rules="formRules.validPhone" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6">
              <v-text-field label="Email" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" v-model="agencyData.ad_contact.email" :rules="[formRules.email.valid]" @input="changedData"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout wrap class="pr-4 pl-4 mt-5" v-if="Agency.is_super_admin">
            <v-flex class="xs12">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Family Settings</b>
              </h5>
            </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex class="xs12 sm6">
              <v-combobox class="hide_dropdown_icon" @change="changedData" v-model="agencyData.account_settings.statuses" label="Profile statuses" hint="hit enter to add new" multiple deletable-chips small-chips></v-combobox>
            </v-flex>
            </v-layout>

          <v-layout wrap class="pr-4 pl-4 mt-5">
          <v-flex class="xs12">
            <h5 class="pf-sub-head mb-3 mt-4 custom-title">
              <b>Video App Settings</b>
            </h5>
          </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12 sm4 pr-4">
            <v-select
              v-model.trim="agencyData.video_app_settings[0].no_of_sections"
              :items="noOfSections"
              label="Number of sections"
              @input="changedData"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 sm4 pr-4">
            <v-select
              v-model.trim="agencyData.video_app_settings[0].no_of_videos_per_section"
              :items="videosPerSection"
              label="Number of videos per section"
              @input="changedData"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 sm4">
            <v-text-field label="Length of video (minutes)" v-model="agencyData.video_app_settings[0].length_of_video" @input="changedData"></v-text-field>
          </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 mt-3 pl-4">
            <v-flex class="xs12 sm10">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Notification Settings</b>
              </h5>
            </v-flex>
            <v-layout wrap class="flex-column">
              <v-switch
                  v-model="selectAllNotifications"
                  @change="toggleSelectAllNotifications()"
                  label="Select All"
                  class="pr-4 mt-0">
              </v-switch>
              <v-layout wrap class="row">
                <v-flex pl-0 v-for="(notification, i) in notifications" :key="i" sm6>
                  <div>
                    <v-checkbox class="ma-0" :label="notificationLabels[i]" v-model="notifications[i]" color="teal" @change="changedData(); updateSelectAllNotifications();"></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
          <v-layout wrap class="pr-4 mt-3 pl-4">
            <v-flex class="xs12 sm10">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Family Notification Settings</b>
              </h5>
            </v-flex>
            <v-layout wrap class="flex-column">
              <v-switch
                  v-model="selectAllFamilyNotifications"
                  @change="toggleSelectAllFamilyNotifications()"
                  label="Select All"
                  class="pr-4 mt-0">
              </v-switch>
              <v-layout wrap class="row">
                <v-flex pl-0 v-for="(notification, i) in familyNotifications" :key="i" sm6>
                  <div>
                    <v-checkbox class="ma-0" :label="familyNotificationLabels[i]" v-model="familyNotifications[i]" color="teal" @change="changedData(); updateSelectAllFamilyNotifications();"></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
          <v-layout class="pr-4 mt-3 pl-4 flex-column">
            <v-flex class="xs12 sm10">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Out of office</b>
              </h5>
            </v-flex>
            <v-layout class="flex-column">
              <v-switch
                  v-model="agencyData.out_of_office.is_out_of_office"
                  label="Is out of office"
                  @change="changedData();">
              </v-switch>
              <v-flex v-if="agencyData.out_of_office.is_out_of_office">
                <v-textarea label="Out of office text" class="ma-0 required" v-model="agencyData.out_of_office.out_of_office_text" :rules="[v => !!v || 'Out of office text is required']" @input="changedData" hint="Used to reply back when any message received" persistent-hint></v-textarea>
              </v-flex>
            </v-layout>
          </v-layout>
      </v-form>
      <v-layout wrap class="pr-4 pl-4 mt-4" v-if="selectedData">
        <v-flex xs12 class="button-container pr-0 text-xs-right">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons(); resetNotificationSettings();">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

      <v-container class="pa-0 pt-5">
        <v-layout>
          <v-flex class="xs12 sm12">
            <v-btn fab absolute right class="mr-3 pf-btn-fab" @click="addAddress">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>    
      <v-container grid-list-md fluid>
        <v-flex class="xs12 sm10">
          <h5 class="pf-sub-head mb-3 custom-title">
            <b>Office Address</b>
          </h5>
        </v-flex>
        <v-card class="mt-3">
        <v-data-table
          :headers="addressHeaders"
          :items="Agency.address"
          :search="search"
          class="pf-data-table" 
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.line_1 || '--' }}</td>
            <td>{{ props.item.line_2 || '--' }}</td>
            <td>{{ props.item.city || '--' }}</td>
            <td>{{ props.item.state ? getStateName(props.item.state) : '--' }}</td>
            <td>{{ props.item.zip || '--' }}</td>
            <td>{{ props.item.phone || '--' }}</td>
            <td align="right">
              <v-btn icon class="ma-0" @click="editClick('address', props.item)">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" @click="deleteClick('address', props.item)">
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
        </v-card>
      </v-container>
    </v-container>

    <v-form v-else-if="editItem.address.index !== -1" ref="addressEditForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <v-btn fab absolute left @click="backToListing('address')" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="saveAddress">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex class="xs12 sm6">
            <v-text-field label="Street Address Line 1" v-model="editItem.address.data.line_1" :rules="formRules.line_1" class="required pr-4 pl-4" @input="changedData"></v-text-field>
            <v-text-field label="Street Address Line 2" v-model="editItem.address.data.line_2" @input="changedData" class="pr-4 pl-4"></v-text-field>
            <v-layout wrap>
              <v-flex class="xs12 sm6 full">
                <v-text-field label="City" class="pr-4 pl-4 required" :rules="formRules.city" v-model="editItem.address.data.city" @input="changedData"></v-text-field>
              </v-flex>
              <v-flex class="xs12 sm6">
                <v-select label="Country" class="required pr-4 pl-4"
                          item-text="name"
                          item-value="id"
                          :rules="formRules.country"
                          v-model="editItem.address.data.country"
                          :items="Country" @change="changedData"></v-select>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex class="xs12 sm6">
                <v-select label="State" item-text="name" item-value="id" :rules="formRules.state" :items="filteredData" v-model="editItem.address.data.state" class="required pr-4 pl-4" @change="changedData"></v-select>
              </v-flex>
              <v-flex class="xs12 sm6">
                <v-text-field label="Zip Code" v-model="editItem.address.data.zip" :rules="formRules.zip" class="required pr-4 pl-4" @input="changedData"></v-text-field>
              </v-flex>
            </v-layout>
            <v-text-field label="Phone Number" v-mask="'(###) ###-####'" class="pr-4 pl-4" v-model="editItem.address.data.phone" :rules="formRules.validPhone" @input="changedData"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="saveAddress">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-form v-if="isEdit && editItem.email.index !== -1" ref="emailEditForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <v-btn fab absolute left @click="backToListing('email')" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="saveEmail">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout>
          <v-flex md6 sm8 xs12>
            <v-text-field spellcheck="false" class="required" :rules="[formRules.email.required, formRules.email.valid]" @input="selectedData=true" v-model="editItem.email.data.email" label="Email Address">
          </v-text-field>
         </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="saveEmail">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-form v-if="isEdit && editItem.phone.index !== -1" ref="phoneEditForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <v-btn fab absolute left @click="backToListing('phone')" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="savePhone">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout>
          <v-flex md6 sm8 xs12>
            <v-text-field label="Phone Number" :rules="formRules.number" v-model="editItem.phone.data.number" @input="selectedData=true" class="pr-4 pl-4 required"></v-text-field>
         </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 sm8 xs12>
            <v-text-field label="Country Code" :rules="formRules.country_code" v-model="editItem.phone.data.country_code" @input="selectedData=true" class="pr-4 pl-4 required"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="savePhone">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>


  </div>
</template>

<script>
/* global session store  */
import { mask } from 'vue-the-mask';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { update, getCollection, remove, isNumber } from '../helpers/helpers';

export default {
  name: 'configuration',
  directives: { mask },
  components: {
    quillEditor
  },
  data: () => ({
    entity: 'Agency',
    editor: null,
    selectAllNotifications: false,
    content: '',
    editorOption: {
      placeholder: 'Add Your Description Here..',
    },
    video_app_settings: {},
    search: '',
    selectedData: false,
    formRules: {
      agencyType: [v => !!v || 'Type is required'],
      agencyName: [v => !!v || 'Name is required'],
      contactName: [v => !!v || 'Contact Name is required'],
      line_1: [v => !!v || 'Address line 1 is required'],
      city: [v => !!v || 'City is required'],
      state: [v => !!v || 'State is required'],
      country: [v => !!v || 'Country is required'],
      faxRules: [v => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid Fax'],
      websiteRules: [v => v === undefined || v === '' || (/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(v)) || 'Please enter valid URL'],
      zip: [v => !!v || 'Zip is required', v => /^(\d{5}|\d{6})$/.test(v) || 'Please enter valid zip code'],
      email: {
        required: v => !!v || 'Email Address is required',
        valid: v => !v || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please Enter a Valid Email Address'
      },
      number: [v => !!v || 'Phone Number is required', v => /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number'],
      validPhone: [v => !v || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number'],
      country_code: [v => !!v || 'Country Code is required', v => /^(\+?\d{1,3}|\d{1,4})$/.test(v) || 'Please enter valid country code'],
      positive_number: [v => !!v || 'Please enter valid number', v => /^\d+$/.test(v) || 'Please enter valid number'],
      integer: [
        v => (!v || isNumber(v)) || 'Please enter a valid number'
      ]
    },
    agencyData: {},
    AgencyType: ['Adoption Agency', 'Adoption Attorney', 'Adoption Services'],
    agencyServices: ['Adoption Mediation', 'Adult Adoptions', 'Birth Parent Counseling', 'Birth Parent Interviews',
      'Contested Adoptions', 'Dependency Interventions', 'Domestic Adoptions Intercountry Adoptions', 'Domestic Home Studies', 'Intercountry Home Studies',
      'Interstate (ICPC)Adoptions', 'Relative Adoptions', 'Stepparent Adoptions', 'Surrogacy', 'Other'],
    managementOptions: [
      { text: 'Child Management', value: 'ChildManagement' },
      { text: 'Family Management', value: 'FamilyManagement' }
    ],
    defaultManagementOption: ['FamilyManagement'],
    addressHeaders: [
      { text: 'Street 1', value: 'line_1' },
      { text: 'Street 2', value: 'line_2' },
      { text: 'City', value: 'city' },
      { text: 'State', value: 'state' },
      { text: 'Zip', value: 'zip' },
      { text: 'Phone', value: 'phone' },
      { text: '', sortable: false },
    ],
    emailHeaders: [
      { text: 'Email Address', value: 'email' },
      { text: '', sortable: false },
    ],
    phoneHeaders: [
      { text: 'Phone', value: 'number' },
      { text: '', sortable: false },
    ],
    editItem: {
      address: {
        index: -1,
        data: {}
      },
      email: {
        index: -1,
        data: {}
      },
      phone: {
        index: -1,
        data: {}
      }
    },
    isEdit: 0,
    noOfSections: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    videosPerSection: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    notificationsBackup: {},
    notifications: {
      agencyRequest: true,
      taskCompleteNotify: true,
      projectCompleteNotify: true,
      photoUploadNotify: true,
      familyDomainCreate: true
    },
    notificationLabels: {
      agencyRequest: 'When agency get a family join request',
      taskCompleteNotify: 'When a parent completes a task',
      projectCompleteNotify: 'When a parent completes their video project',
      photoUploadNotify: 'When a parent completes uploading photos for the design book',
      albumPhotoUploadNotify: 'When a parent uploading photos to any of their albums',
      familyDomainCreate: 'When a parent domain registered',
    },
    familyNotificationsBackup: {},
    familyNotifications: {
      notify_badge_contact: false
    },
    familyNotificationLabels: {
      notify_badge_contact: 'Send contacts to individual account'
    },
    outOfOffice: {
      is_out_of_office: false,
      out_of_office_text: 'We are out of office right now, will contact you soon. Thank you'
    },
    profileStatusList: ['New', 'Open', 'Layout', 'Video', 'Writing'],
    agencyBlogCategories: [],
    categoriesLoading: false
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Country', 'State']),
    icon () {
      if (this.agencyData.services.length === 14) return 'check_box';
      if (this.agencyData.services.length === 0) return 'check_box_outline_blank';
      return 'indeterminate_check_box';
    },
    filteredData () {
      let countryId = typeof this.editItem.address.data.country === 'object' ? this.editItem.address.data.country.id : this.editItem.address.data.country;
      let options = this.State;
      return options.filter(o => o.country.id === countryId);
    },
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    },
    isWebsiteValid () {
      if (this.agencyData.website) {
        return this.formRules.websiteRules[0](this.agencyData.website) === true;
      }
      return false;
    },
  },
  // eslint-disable-next-line
  created () {
    this.agencyData = JSON.parse(JSON.stringify(this.Agency));

    // Fetch the agency blog categories
    this.fetchAgencyBlogCategories();

    if (!this.agencyData.phone[0]) {
      this.agencyData.phone.push({});
    }
    if (!this.agencyData.email[0]) {
      this.agencyData.email.push({});
    }
    if (this.agencyData.pull_blogs === undefined) {
      this.agencyData.pull_blogs = true;
    }
    if (!this.agencyData.blog_category) {
      this.agencyData.blog_category = [];
    }
    if (!this.agencyData.video_app_settings[0]) {
      this.agencyData.video_app_settings.push({
        no_of_sections: 5,
        no_of_videos_per_section: 1,
        length_of_video: '2.30'
      });
    }
    if (!this.agencyData.account_settings) {
      this.agencyData.account_settings = {};
    }
    if (!this.agencyData.account_settings.statuses || !this.agencyData.account_settings.statuses.length) {
      this.agencyData.account_settings.statuses = this.profileStatusList;
    }
    if (!this.agencyData.feature_settings || !this.agencyData.feature_settings.length)
    {
      this.agencyData.feature_settings = this.defaultManagementOption;
    }

    this.setAdditionalContacts();

    /* Add Admin to the type list */
    if (this.agencyData.is_admin) {
      this.AgencyType.unshift('Admin');
    }

    this.initializeState();

    // Update the SelectAllNotifications
    if (this.agencyData && this.agencyData.email_notification_settings && Object.keys(this.agencyData.email_notification_settings).length) {
      /* Set the album photo upload notyfy as false - by default */
      if (typeof this.agencyData.email_notification_settings.albumPhotoUploadNotify === 'undefined') {
        this.agencyData.email_notification_settings.albumPhotoUploadNotify = false;
      }
      this.notifications = this.agencyData.email_notification_settings;
    }
    /* Set the out of office fields by default */
    if (this.agencyData && !this.agencyData.out_of_office) {
      this.agencyData.out_of_office = this.outOfOffice;
    }
    this.notificationsBackup = JSON.parse(JSON.stringify(this.notifications));
    this.updateSelectAllNotifications();

    // Update the SelectAllFamilyNotifications
    if (this.agencyData && this.agencyData.family_notification_settings && Object.keys(this.agencyData.family_notification_settings).length) {
      this.familyNotifications = this.agencyData.family_notification_settings;
    }
    this.familyNotificationsBackup = JSON.parse(JSON.stringify(this.familyNotifications));
    this.updateSelectAllFamilyNotifications();
  },
  methods: {
    toggleSelectAll () {
      this.$nextTick(() => {
        console.log('inside nextTick');
        this.selectedData = true;
        if (this.agencyData.services.length === 14) {
          this.agencyData.services = [];
        } else {
          this.agencyData.services = this.agencyServices.slice();
        }
      });
    },
    toggleSelectAllManagementOptions () {
      this.$nextTick(() => {
        console.log('inside ManagementToggle');
        this.selectedData = true;
      });
    },
    toggleSelectAllNotifications () {
      this.changedData();
      Object.keys(this.notifications).forEach(x => {
        this.notifications[x] = this.selectAllNotifications;
      });
    },
    updateSelectAllNotifications () {
      // Set SelectAll if all checked
      let trueCount = 0;
      Object.keys(this.notifications).forEach(x => {
        if (this.notifications[x]) trueCount++;
      });
      if (Object.keys(this.notifications).length === trueCount) {
        this.selectAllNotifications = true;
      } else {
        this.selectAllNotifications = false;
      }
    },
    toggleSelectAllFamilyNotifications () {
      this.changedData();
      Object.keys(this.familyNotifications).forEach(x => {
        this.familyNotifications[x] = this.selectAllFamilyNotifications;
      });
    },
    updateSelectAllFamilyNotifications () {
      // Set SelectAll if all checked
      let trueCount = 0;
      Object.keys(this.familyNotifications).forEach(x => {
        if (this.familyNotifications[x]) trueCount++;
      });
      if (Object.keys(this.familyNotifications).length === trueCount) {
        this.selectAllFamilyNotifications = true;
      } else {
        this.selectAllFamilyNotifications = false;
      }
    },
    getStateName (state) {
      let stateObj = this.State.find(o => o.id === state.id);
      let stateName = stateObj ? stateObj.name : '';
      return stateName;
    },
    changedData () {
      this.selectedData = true;
    },
    validateBlogPull () {
      if (this.agencyData.pull_blogs && this.agencyData.website && this.isWebsiteValid) {
        let website = this.agencyData.website.indexOf('http') === -1 ? 'https://' + this.agencyData.website : this.agencyData.website;
        website = website.endsWith('/') ? website.slice(0, -1) : website;

        fetch(website + '/wp-json/cairs/v1/latest-posts')
          .then(async (response) => {
            if (response.status === 200) {
              this.agencyData.pull_blogs = true;
              // Fetch the categories also
              await this.fetchAgencyBlogCategories();
            } else {
              this.agencyData.pull_blogs = false;
              swal.fire({
                type: 'error',
                title: 'Blog URL Not Reachable',
                text: 'We could not reach your blog URL. Please reach out at support@parentfinder.com. We have disabled the blog pull down option.',
                showConfirmButton: true
              });
            }
          })
          .catch(error => {
            this.agencyData.pull_blogs = false;
            swal.fire({
              type: 'error',
              title: 'Invalid Blog URL',
              text: 'Please enter a valid blog URL. We have disabled the blog pull down option.',
              showConfirmButton: true
            });
          });
      }
      this.changedData();
    },
    async fetchAgencyBlogCategories () {
      const website = this.agencyData.website.indexOf('http') === -1 ? 'https://' + this.agencyData.website : this.agencyData.website;
      try {
        this.categoriesLoading = true;
        const categoriesRes = await fetch(website + '/wp-json/wp/v2/categories');
        if (categoriesRes.status === 200) {
          this.agencyBlogCategories = await categoriesRes.json();
        }
      } catch (e) {
        console.log('Could not fetch categories');
      } finally {
        this.categoriesLoading = false;
      }
    },
    hideButtons () {
      this.selectedData = false;
      this.agencyData = JSON.parse(JSON.stringify(this.Agency));
      if (!this.agencyData.phone[0]) {
        this.agencyData.phone.push({});
      }
      if (!this.agencyData.email[0]) {
        this.agencyData.email.push({});
      }
    },
    resetNotificationSettings () {
      this.notifications = JSON.parse(JSON.stringify(this.notificationsBackup));
      this.updateSelectAllNotifications();

      this.familyNotifications = JSON.parse(JSON.stringify(this.familyNotificationsBackup));
      this.updateSelectAllFamilyNotifications();
    },
    editClick (type, item) {
      this.hideButtons();
      this.isEdit = 1;
      this.editItem[type].data = Object.assign({}, item);
      if (type === 'address') {
        this.feedSelects('Country');
        // this.feedSelects('State');
        let addressIndex = this.Agency.address.indexOf(item);
        this.editItem.address.index = addressIndex;
      } else if (type === 'email') {
        let emailIndex = this.Agency.email.indexOf(item);
        this.editItem.email.index = emailIndex;
      } else if (type === 'phone') {
        let phoneIndex = this.Agency.phone.indexOf(item);
        this.editItem.phone.index = phoneIndex;
      }
    },
    deleteClick (type, item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let itemIndex = this.Agency[type].indexOf(item);
            this.Agency[type].splice(itemIndex, 1);
            type = type === 'phone' ? 'phone number' : type;
            this.Agency.updated_from = 'configuration';
            let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
            if (error) {
              console.log('error', error);
            } else {
              this.Agency = Object.assign({}, data);
              swal.fire(
                'Deleted!',
                'The ' + type.charAt(0).toUpperCase() + type.slice(1) + ' has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    async feedSelects (entity) {
      if (!this[entity].length) {
        let { data, total, error } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          switch (entity) {
            case 'Country':
              store.commit('setCountry', data);
              break;
            case 'State':
              this.states = data;
              break;
            default:
              break;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let { error, data } = await getCollection('State', true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setState', data);
          }
        }
      }
    },
    setAdditionalContacts () {
      let defaultContact = {
        email: this.agencyData.email && this.agencyData.email.length ? this.agencyData.email[0].email : '',
        phone: this.agencyData.phone && this.agencyData.phone.length ? this.agencyData.phone[0].number : '',
        text: this.agencyData.fax ? this.agencyData.fax : ''
      };
      if (!this.agencyData.bm_contact) {
        this.agencyData.bm_contact = defaultContact;
      } else {
        this.agencyData.bm_contact.email = this.agencyData.bm_contact.email || defaultContact.email;
        this.agencyData.bm_contact.phone = this.agencyData.bm_contact.phone || defaultContact.phone;
        this.agencyData.bm_contact.text = this.agencyData.bm_contact.text || defaultContact.text;
      }
      if (!this.agencyData.ad_contact) {
        this.agencyData.ad_contact = defaultContact;
      } else {
        this.agencyData.ad_contact.email = this.agencyData.ad_contact.email || defaultContact.email;
        this.agencyData.ad_contact.phone = this.agencyData.ad_contact.phone || defaultContact.phone;
        this.agencyData.ad_contact.text = this.agencyData.ad_contact.text || defaultContact.text;
      }
    },
    async save () {
      if (this.$refs.configForm.validate()) {

        if (this.agencyData.feature_settings[0] === 'ChildManagement' && (!this.agencyData.map_url || !this.agencyData.map_id || !this.agencyData.map_sub_id)) {
          swal.fire({
            type: 'warning',
            title: 'MAP data missing',
            text: 'Please enter the MAP URL, ID and Sub ID for child management',
            showConfirmButton: false,
            timer: 2500
          });
          return false;
        }

        this.agencyData.updated_from = 'configuration';
        this.agencyData.video_app_settings[0].no_of_sections = (this.agencyData.video_app_settings[0].no_of_sections) ? parseInt(this.agencyData.video_app_settings[0].no_of_sections, 10) : 0;
        this.agencyData.video_app_settings[0].no_of_videos_per_section = (this.agencyData.video_app_settings[0].no_of_videos_per_section) ? parseInt(this.agencyData.video_app_settings[0].no_of_videos_per_section, 10) : 0;

        // Set the Email notification settings
        if (Object.keys(this.notifications).length) {
          this.agencyData.email_notification_settings = this.notifications;
        }
        // Set the Family email notification settings
        if (Object.keys(this.familyNotifications).length) {
          this.agencyData.family_notification_settings = this.familyNotifications;
        }
        if (!this.agencyData.feature_settings || !this.agencyData.feature_settings.length)
        {
          swal.fire({
            type: 'warning',
            title: 'Please choose the management options to save',
            showConfirmButton: false,
            timer: 2500
          });
          return false;
          
        }
        // Remove duplicates from blog categories
        if (this.agencyData.blog_category.length) {
          this.agencyData.blog_category = Array.from(new Set(this.agencyData.blog_category.filter(item => typeof item === 'number')));
        }

        let { error, data, status } = await update(this.entity, this.agencyData, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          this.notifications = this.Agency.email_notification_settings;
          this.notificationsBackup = JSON.parse(JSON.stringify(this.notifications));
          swal.fire({
            type: 'success',
            title: 'Details saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.isEdit = 0;
              this.hideButtons();
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    addAddress () {
      this.$router.push({ path: '/address' });
    },
    async saveAddress () {
      if (this.$refs.addressEditForm.validate()) {
        this.Agency.address[this.editItem.address.index] = this.editItem.address.data;
        this.Agency.updated_from = 'configuration';
        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          swal.fire({
            type: 'success',
            title: 'Details saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.isEdit = 0;
              this.hideButtons();
              this.editItem.address = {
                data: {},
                index: -1
              };
            }
          });
        }
      }
    },
    async saveEmail () {
      if (this.$refs.emailEditForm.validate()) {
        this.Agency.email[this.editItem.email.index] = this.editItem.email.data;
        this.Agency.updated_from = 'configuration';
        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          swal.fire({
            type: 'success',
            title: 'Details saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.isEdit = 0;
              this.hideButtons();
              this.editItem.email = {
                data: {},
                index: -1
              };
            }
          });
        }
      }
    },
    async savePhone () {
      if (this.$refs.phoneEditForm.validate()) {
        this.Agency.phone[this.editItem.phone.index] = this.editItem.phone.data;
        this.Agency.updated_from = 'configuration';
        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          swal.fire({
            type: 'success',
            title: 'Details saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.isEdit = 0;
              this.hideButtons();
              this.editItem.phone = {
                data: {},
                index: -1
              };
            }
          });
        }
      }
    },
    backToListing (type) {
      this.isEdit = 0;
      this.editItem[type].data = Object.assign({}, {});
      this.editItem[type].index = -1;
    }
  }
};
</script>

<style lang="css" scoped>
@-moz-document url-prefix() {
    .v-list__tile__action > .v-icon {
      padding: 12px !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/Configuration.vue